// ** Utils
import { paginateArray } from '@utility/belt'

// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { combineReducers } from 'redux'


const appBaseURL = import.meta.env.VITE_APP_BASE_URL
// const appBaseURL = import.meta.env.VITE_APP_BASE_URL
// console.log(appBaseURL)
// ** START:  
export const getBankingAccountListF01Data = createAsyncThunk('appBanking/getBankingAccountListF01Data', async (params, thunkAPI) => {
    try {

        const state = thunkAPI.getState() 

        const { sort, sortColumn, page = 1, perPage = 10, q = '', caller = '' } = params

        // if (import.meta.env.DEV) {
        //     console.log(`Called by ${caller}`)
        // }

        let data
        let tempIsDataLoaded

        /* Note state.bankingAccount is defined in 
        index.js or a js file 
        calling 
        const store = useSelector(state => state.bankingAccount.bankingAccountListF01) */
        if (!state.bankingAccount.bankingAccountListF01.isDataLoaded) {

            const response = await fetch(`${appBaseURL}/banking/get-banking-account-list-f01`)
            if (!response.ok) {
                throw new Error('Fetch response error at getBankingAccountListF01Data', response.statusText)
            }
            // if (import.meta.env.DEV) {
            //     console.log('API call to /Banking/getBankingAccountListF01')
            // }

            data = await response.json()
            tempIsDataLoaded = true
        } else {

            data = state.bankingAccount.bankingAccountListF01.allData
            tempIsDataLoaded = state.bankingAccount.bankingAccountListF01.isDataLoaded
        }

        // Get from cache if isDataLoaded is false:

        const dataAsc = [...data].sort((a, b) => { // Pass a copy [...data] only to sort()
            if (a[sortColumn]) {
                return a[sortColumn] < b[sortColumn] ? -1 : 1
            } else {
                const splitColumn = sortColumn.split('.')
                const columnA = a[splitColumn[0]][splitColumn[1]]
                const columnB = b[splitColumn[0]][splitColumn[1]]
                return columnA < columnB ? -1 : 1
            }
        })

        const dataToFilter = sort === 'asc' ? dataAsc : dataAsc.reverse()

        const queryLowered = q.toLowerCase()

        const filteredData = dataToFilter.filter( 
            bankingAccount => { 
                return ((bankingAccount.holderName.toLowerCase().includes(queryLowered) ||
                bankingAccount.bankName.toLowerCase().includes(queryLowered) ||
                bankingAccount.bankAddress.toLowerCase().includes(queryLowered)) 
                )
            }
        )

        return {
            params,
            data: filteredData.length <= perPage ? filteredData : paginateArray(filteredData, perPage, page),
            allData: data,
            totalPages: filteredData.length, // TODO: Doesnt work:  Math.ceil(filteredData.length / perPage) or totalPages is a misnomer
            isDataLoaded: tempIsDataLoaded,
            caller
        }

    } catch (error) {
        return thunkAPI.rejectWithValue(error.message)  

    }

})

export const bankingAccountListF01Slice = createSlice({
    name: 'bankingAccountListF01Slice',
    initialState: {
        params: {},
        data: [],
        allData: [],
        total: 0,
        totalPages: 0,
        loading: false, 
        isDataLoaded: false, // Controls caching mechanism to avoid unnecessary retrieval from DB 
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null 
    },

    reducers: {
        setIsDataLoaded: (state, action) => {
            state.isDataLoaded = action.payload
        }
    },

    extraReducers: builder => {
    builder.addCase(getBankingAccountListF01Data.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.allData = action.payload.allData
        state.total = action.payload.totalPages
        state.params = action.payload.params
        state.loading = false
        // state.isDataLoaded = true is handled by async thunk's return
        state.isDataLoaded = action.payload.isDataLoaded || false // Take value from async thunk's return
        state.rejected = false
        state.error = null
    })
    builder.addCase(getBankingAccountListF01Data.pending, (state) => {
        state.loading = true 
        state.rejected = false
        state.error = null
    })
    builder.addCase(getBankingAccountListF01Data.rejected, (state, action) => {
        state.loading = false
        state.rejected = true
        state.error = action.error.message
        state.errActPload = action.payload
        state.errActMsg = action.error.message

        if (import.meta.env.DEV) {
            console.error(`Fetch failure at getBankingAccountListF01Data as called by ${action.payload.caller}:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
        }
    })
    }
})

// ** START:  
export const getBankingAccountRowF01Data = createAsyncThunk('appBanking/getBankingAccountRowF01Data', async (id, thunkAPI) => {
    try {
        const response = await fetch(`${appBaseURL}/banking/get-banking-account-row-f01?rowId=${id}`)
        if (!response.ok) {
            throw new Error('Fetch response error at getBankingAccountRowF01Data', response.statusText)
        }
        const data = await response.json()  
        return data  

    } catch (error) {
        if (import.meta.env.DEV) {
            console.error('Fetch failure at getBankingAccountRowF01Data try-catch:', error)
        }
        return thunkAPI.rejectWithValue(error.message)  
    }
})

export const bankingAccountRowF01Slice = createSlice({
    name: 'bankingAccountRowF01Slice',
    initialState: {
        data: null,
        loading: false,
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null
    },
    // reducers: {},
    extraReducers: (builder) => {
    builder
        .addCase(getBankingAccountRowF01Data.fulfilled, (state, action) => {
            state.data = action.payload
            state.loading = false
            state.rejected = false
            state.error = null
        })
        .addCase(getBankingAccountRowF01Data.pending, (state) => {
            state.loading = true
            state.rejected = false
            state.error = null
        })
        .addCase(getBankingAccountRowF01Data.rejected, (state, action) => {
            state.loading = false
            state.rejected = true
            state.error = action.error.message
            state.errActPload = action.payload
            state.errActMsg = action.error.message
            if (import.meta.env.DEV) {
                console.error(`Fetch failure at getBankingAccountRowF01Data:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
            }
        })
    }
})


// ** START Update
export const updateBankingAccount = createAsyncThunk('appBanking/updateBankingAccount', async ({id, modifiedFields}, thunkAPI) => {
    try {
        const response = await fetch(`${appBaseURL}/banking/update-banking-account/${id}`, {
            method: 'PUT', 
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(modifiedFields)
        })

        // console.log(process.env.NODE_ENV)
        if (response.ok) {
            if (response.status === 204) { 
                // Update successful. No Content returned from endpoint
                return null
            } else {
                const data = await response.json()
                return data
            }
        } else {
            return thunkAPI.rejectWithValue(await response.json())
        }

    } catch (error) {
        return thunkAPI.rejectWithValue(error.message)
    }
})

export const bankingAccountUpdateSlice = createSlice({
    name: 'bankingAccountUpdateSlice',
    initialState: {
        data: null,
        loading: false,
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null
    },
    // reducers: {},
    extraReducers: (builder) => {
    builder
        .addCase(updateBankingAccount.fulfilled, (state, action) => {
            state.data = action.payload
            state.loading = false
            state.rejected = false
            state.error = null
        })
        .addCase(updateBankingAccount.pending, (state) => {
            state.loading = true
            state.rejected = false
            state.error = null
        })
        .addCase(updateBankingAccount.rejected, (state, action) => {
            state.loading = false
            state.rejected = true
            state.error = action.error.message
            state.errActPload = action.payload
            state.errActMsg = action.error.message
            if (import.meta.env.DEV) {
                console.error(`Update failure at updateBankingAccount:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
            }
        })
    }
})


// ** START Create
export const createBankingAccount = createAsyncThunk('appBanking/createBankingAccount', async ({modifiedFields}, thunkAPI) => {
    try {
        const response = await fetch(`${appBaseURL}/banking/create-banking-account`, {
            method: 'POST', 
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(modifiedFields)
        })

        if (response.ok) {
            if (response.status === 204) { 
                    // Creation successful. No Content returned from endpoint
                    return null
            } else {
                const data = await response.json()
                return data
            }
        } else {
            return thunkAPI.rejectWithValue(await response.json())
        }

    } catch (error) {
        return thunkAPI.rejectWithValue(error.message)
    }
})

export const bankingAccountCreateSlice = createSlice({
    name: 'bankingAccountCreateSlice',
    initialState: {
        data: null,
        fulfilled: false,
        loading: false,
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null
    },
    reducers: {
        resetCreateState: (state) => {
            state.data = null
            state.fulfilled = false
            state.loading = false
            state.rejected = false
            state.error = null
            state.errActPload = null
            state.errActMsg = null
        }
    },
    extraReducers: (builder) => {
    builder
        .addCase(createBankingAccount.fulfilled, (state, action) => {
            state.data = action.payload
            state.fulfilled = true
            state.loading = false
            state.rejected = false
            state.error = null
            if (import.meta.env.DEV) {
                console.log(`Success at createBankingAccount:\n Data: ${JSON.stringify(state.data, null, 2)}`)
            }
        })
        .addCase(createBankingAccount.pending, (state) => {
            state.fulfilled = false
            state.loading = true
            state.rejected = false
            state.error = null
        })
        .addCase(createBankingAccount.rejected, (state, action) => {
            state.fulfilled = false
            state.loading = false
            state.rejected = true
            state.error = action.error.message
            state.errActPload = action.payload
            state.errActMsg = action.error.message
            if (import.meta.env.DEV) {
                console.error(`Create failure at createBankingAccount\:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
            }
        })
    }
})


// ** START Delete
export const deleteBankingAccount = createAsyncThunk('appBanking/deleteBankingAccount', async (id, thunkAPI) => {
    try {
        const response = await fetch(`${appBaseURL}/banking/delete-banking-account/${id}`, {
            method: 'DELETE', 
            headers: { 
                'Content-Type': 'application/json'
                // TBI: 'Authorization': 'Bearer ' + AccessToken 
            }
        })

        if (response.ok) {
            if (response.status === 204) { 
                // Update successful. No Content returned from endpoint
                return null
            } else {
                const data = await response.json()
                return data
            }
        } else {
            return thunkAPI.rejectWithValue(await response.json())
        }

    } catch (error) {
        return thunkAPI.rejectWithValue(error.message)
    }
})

export const bankingAccountDeleteSlice = createSlice({
    name: 'bankingAccountDeleteSlice',
    initialState: {
        data: null,
        loading: false,
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null
    },
    // reducers: {},
    extraReducers: (builder) => {
    builder
        .addCase(deleteBankingAccount.fulfilled, (state, action) => {
            state.data = action.payload
            state.loading = false
            state.rejected = false
            state.error = null
        })
        .addCase(deleteBankingAccount.pending, (state) => {
            state.loading = true
            state.rejected = false
            state.error = null
        })
        .addCase(deleteBankingAccount.rejected, (state, action) => {
            state.loading = false
            state.rejected = true
            state.error = action.error.message
            state.errActPload = action.payload
            state.errActMsg = action.error.message
        if (import.meta.env.DEV) {
            console.error(`Delete failure at deleteBankingAccount:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
        }
        })
    }
})

// Used for dropdown menu:
export const getBankingAccountListF02Data = createAsyncThunk('appBanking/getBankingAccountListF02Data', async (params, thunkAPI) => {
    try {

        const response = await fetch(`${appBaseURL}/banking/get-banking-account-list-f02`)
        if (!response.ok) {
            throw new Error('Fetch response error at getBankingAccountListF02Data', response.statusText)
        }

        const data = await response.json()

        return {
            params,
            data
        }

    } catch (error) {
        console.log(error.message)
        return thunkAPI.rejectWithValue(error.message)  
    }

})

export const bankingAccountListF02Slice = createSlice({
    name: 'bankingAccountListF02Slice',
    initialState: {
        params: {},
        data: [],
        total: 0,
        loading: false, 
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null 
    },

    extraReducers: builder => {
    builder.addCase(getBankingAccountListF02Data.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.loading = false
        state.rejected = false
        state.error = null
    })
    builder.addCase(getBankingAccountListF02Data.pending, (state) => {
        state.loading = true 
        state.rejected = false
        state.error = null
    })
    builder.addCase(getBankingAccountListF02Data.rejected, (state, action) => {
        state.loading = false
        state.rejected = true
        state.error = action.error.message
        state.errActPload = action.payload
        state.errActMsg = action.error.message

        if (import.meta.env.DEV) {
            console.error(`Fetch failure at getBankingAccountListF02Data:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
        }
    })
    }
})

// Export actions
export const { setIsDataLoaded } = bankingAccountListF01Slice.actions
export const { resetCreateState } = bankingAccountCreateSlice.actions

// Combine reducers
const bankingAccountReducer = combineReducers({
    bankingAccountListF01: bankingAccountListF01Slice.reducer,
    bankingAccountListF02: bankingAccountListF02Slice.reducer,
    bankingAccountRowF01: bankingAccountRowF01Slice.reducer,
    bankingAccountCreate: bankingAccountCreateSlice.reducer,
    bankingAccountUpdate: bankingAccountUpdateSlice.reducer,
    bankingAccountDelete: bankingAccountDeleteSlice.reducer
})


export default bankingAccountReducer